exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedule-icon svg{width:24px;height:24px;background-color:#e4e5e9;border-radius:50%;padding:.4em}", ""]);

// exports
